import { useQuery } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { SearchIncidentsAnalyticsTableParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";
import useSnackbar from "utils/useSnackbar";

const searchIncidentAnalyticsTableDocument = graphql(/* GraphQL */ `
	query searchIncidentAnalyticsTable(
		$params: SearchIncidentsAnalyticsTableParams!
	) {
		searchIncidentAnalyticsTable(params: $params) {
			total_count {
				value
			}
			incidents {
				...searchIncidentAnalyticsTableItemFields
			}
		}
	}
`);

const searchIncidentAnalyticsTable = (
	params: SearchIncidentsAnalyticsTableParams,
	userId?: string
) =>
	client(userId)
		.request(searchIncidentAnalyticsTableDocument, { params })
		.then((res) => res.searchIncidentAnalyticsTable);

const useSearchIncidentAnalyticsTable = (
	params: SearchIncidentsAnalyticsTableParams | null
) => {
	const { _id, userId } = useActiveAccount();
	const { handleError } = useSnackbar();

	return useQuery(
		["user", userId, "account", _id, "searchIncidentAnalyticsTable", params],
		() => searchIncidentAnalyticsTable(params!, userId),
		{
			enabled:
				!!_id &&
				!!params &&
				!!(params.longkey || params.geo_filter || params.asset_set_id) &&
				!!(params.after || params.relative_timestamp),
			onError: handleError,
		}
	);
};

export default useSearchIncidentAnalyticsTable;
